// Sign-up routes point to the coming soon page until the app portal is live.

export const COMING_SOON_PATH = "/coming-soon";

export const AUTH_LINKS = {
  brandSignUp: COMING_SOON_PATH,
  creatorSignUp: COMING_SOON_PATH,
};
